import { Link, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "./blog.css";
import { BasePage } from "../base/base";
import { Loading } from "./loading";
import { RiSearchLine } from "react-icons/ri";
import { HiMiniXMark } from "react-icons/hi2";
import { getPost, getMeta, getMetaPost, searchPosts } from "../api/api";

const tagColors = {
  w: "var(--bg_highlight)",
  a: "var(--dark3)",
  o: "var(--fg_gutter)",
  e: "var(--blue0)",
  i: "var(--comment)",
  u: "var(--blue7)",
  y: "var(--terminal_black)",
  selected: "var(--primary)",
};

const featuredTags = [
  "htb",
  "writeup",
  "linux",
  "s6",
  "windows",
  "programming",
  "python",
];

const Tag = ({ tag }) => {
  // check if tag is currently selected
  const [searchParams] = useSearchParams();
  const selected = searchParams.get("q") === "#" + tag;

  const getTagColor = (tag) => {
    if (tag.length === 0) {
      return tagColors["a"];
    }
    let c = tag[0].toLowerCase();
    if (c in tagColors) {
      return tagColors[tag[0].toLowerCase()];
    } else {
      return getTagColor(tag.slice(1));
    }
  };
  return (
    <Link
      className="blog-tag"
      to={selected ? "/blog?q=" : "/blog?q=%23" + tag}
      style={{ backgroundColor: getTagColor(tag) }}
      selected={selected.toString()}
    >
      {tag}
    </Link>
  );
};

const FeaturedTags = () => {
  return (
    <div className="featured-tags">
      {featuredTags.map((tag, index) => (
        <Tag key={index} tag={tag} />
      ))}
    </div>
  );
};

const PostPreview = ({ title, date, tags, description, slug }) => {
  return (
    <div className="post-preview">
      <div className="post-preview-meta">
        <p className="post-preview-date">
          {new Date(date).toLocaleDateString("en-DE", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          })}
        </p>
        <h2 className="post-preview-title">
          <Link to={slug}>{title}</Link>
        </h2>
      </div>
      <p className="post-preview-description">{description}</p>
      <div className="post-preview-tags">
        {tags.map((tag, index) => (
          <Link
            to={"/blog?q=%23" + tag}
            key={index}
            className="post-preview-tag"
          >
            {tag}
          </Link>
        ))}
      </div>
    </div>
  );
};

const Latest = ({ posts }) => {
  const [latest, setLatest] = useState([]);

  useEffect(() => {
    let sorted = posts.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    setLatest(sorted.slice(0, 3));
  }, [posts]);

  return (
    <div className="blog-latest">
      <h1>featured</h1>
      <div className="latest-posts post-container">
        {latest.map((post, index) => (
          <PostPreview key={index} {...post} />
        ))}
      </div>
    </div>
  );
};

const SearchBar = ({ callback }) => {
  const search = () => {
    let query = document.getElementById("blog-search-input").value;
    setSearchParams({ q: query });
    callback(query);
  };

  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q");
  useEffect(() => {
    if (query) {
      callback(query);
    }
  }, [query]);

  return (
    <div className="blog-search">
      <RiSearchLine
        className="blog-search-lens-icon"
        strokeWidth={0.5}
        size={"1.75rem"}
        onClick={search}
      />
      <input
        type="text"
        placeholder="search"
        id="blog-search-input"
        onChange={search}
        value={query ? query : ""}
      />
      <HiMiniXMark
        className="blog-search-cancel-icon"
        strokeWidth={1.25}
        size={"1.25rem"}
        onClick={() => {
          document.getElementById("blog-search-input").value = "";
          search();
        }}
      />
    </div>
  );
};

const AllPosts = ({ posts }) => {
  return (
    <div className="blog-all">
      <div className="all-posts post-container">
        {posts.map((post, index) => (
          <PostPreview key={index} {...post} />
        ))}
      </div>
    </div>
  );
};

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const gatherPosts = () => {
    getMeta().then((meta) => {
      setPosts(meta);
      setFiltered(meta);
    });
  };
  const callback = (query) => {
    if (query.trim() === "") {
      setFiltered(posts);
      return;
    }
    searchPosts(query).then((data) => {
      setFiltered(data);
    });
  };
  useEffect(() => {
    gatherPosts();
  }, []);
  return (
    <BasePage>
      {posts ? (
        <div className="blog-page">
          <h1>lstuma's Blog</h1>
          <FeaturedTags />
          <Latest posts={posts} />
          <SearchBar callback={callback} />
          <AllPosts posts={filtered} />
        </div>
      ) : (
        <Loading />
      )}
    </BasePage>
  );
};

export { BlogPage, Tag };
